import type { components } from '@/api/schema'

export type ShareSource = components['schemas']['ShareSource']

const sources = new Set<ShareSource>([
  'whatsapp',
  'instagram',
  'facebook',
  'copy',
])

export function shareSource(value: string | null): ShareSource | undefined {
  return sources.has(value as ShareSource) ? (value as ShareSource) : undefined
}
